import React, { useState } from "react";
import PropTypes from "prop-types";

import { Modal } from "@wwg/ui";
import ModalActionBar from "shared/ModalActionBar";
import Button from "shared/Button";
import Input from "shared/@forms/Input";
import TextArea from "shared/@forms/TextArea";
import { Select } from "shared/Select/Select";

import styles from "./CreateNewReminderModal.module.css";

/**
 * Modal that opens when add reminder is clicked in the actions dropdown on an incident details page.
 */
export function CreateNewReminderModal({ onCreate, isOpen, onClose }) {
  const [reminderData, setReminderData] = useState({});
  const [reminderDays, setReminderDays] = useState("Select");
  const [errors, setErrors] = useState({});

  const selectOptions = new Array(14);
  for (let i = 0; i < selectOptions.length; i++) {
    selectOptions[i] = (i + 1).toString();
  }

  const handleForm = (e) => {
    setReminderData({
      ...reminderData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSumbittal = () => {
    let tempErrors = {
      title: "",
      reminderDays: "",
    };
    if (!reminderData.title)
      tempErrors = { ...tempErrors, title: "Please enter a title" };
    if (reminderDays === "Select")
      tempErrors = {
        ...tempErrors,
        reminderDays: "Please select when to be reminded",
      };
    if (tempErrors.title || tempErrors.reminderDays)
      setErrors({ ...tempErrors });
    else {
      setErrors({});
      onCreate({
        title: reminderData.title,
        notes: reminderData.notes,
        reminderDays: reminderDays,
      });
      onClose();
    }
  };

  return (
    <Modal
      onClose={onClose}
      visible={isOpen}
      onClick={onClose}
      children={
        <div className={styles.modalBody}>
          <div className={styles.title}> Add Reminder </div>
          <div className={styles.hr}></div>

          <span className={styles.label}>Reminder Reason</span>
          <Input
            name="title"
            placeholder="Title"
            className={styles.input}
            onChange={(e) => handleForm(e)}
            onInput={() => setErrors({ ...errors, title: "" })}
          />
          <span className={styles.error}>{errors.title && errors.title}</span>
          <div className={styles.label}>Add Reminder Notes</div>
          <TextArea
            name="notes"
            className={styles.textArea}
            placeholder="Notes"
            onChange={(e) => handleForm(e)}
          />
          <span className={styles.label}>Set Reminder</span>
          <span className={styles.reminderContainer}>
            <span>Remind me in </span>
            <span className={styles.select}>
              <Select
                options={selectOptions}
                placeholder={reminderDays}
                onChange={setReminderDays}
              />
            </span>
            <span> days.</span>
          </span>
          <span className={styles.error} style={{ marginTop: "0.25em" }}>
            {errors.reminderDays && errors.reminderDays}
          </span>
          <ModalActionBar>
            <Button
              className={styles.createButton}
              onClick={() => handleSumbittal()}
            >
              Create
            </Button>
          </ModalActionBar>
        </div>
      }
    ></Modal>
  );
}

CreateNewReminderModal.propTypes = {
  /** Function called when the Create btn is clicked.  */
  onCreate: PropTypes.func,
  /** Getter to determine if modal is displayed  */
  isOpen: PropTypes.bool,
  /** Callback function for when the modal is closed  */
  onClose: PropTypes.func,
};
